export default function Footer(){
	return (<div className="footer">
				<p> A collection of web3 projects by </p>
				<p> Priyanshu Ahuja </p>
				<p style={{ }}>

					<a style={{marginRight: '2rem'}} target="_external"  href="https://www.linkedin.com/in/priyanshuahuja/">
					<i className="pi pi-linkedin" /> LinkedIN
					</a>
					<a href="https://github.com/Priyanshu-001/" target="_external" >
					<i className="pi pi-github" /> GitHub
					</a>
				</p>

			</div>
			)
}